var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudioUnmuted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.66665 7.99984V3.33317C9.66665 2.4127 8.92045 1.6665 7.99998 1.6665C7.0795 1.6665 6.33331 2.4127 6.33331 3.33317V7.99984C6.33331 8.92031 7.07951 9.6665 7.99998 9.6665C8.92045 9.6665 9.66665 8.92031 9.66665 7.99984ZM7.99998 0.666504C6.52722 0.666504 5.33331 1.86041 5.33331 3.33317V7.99984C5.33331 9.4726 6.52722 10.6665 7.99998 10.6665C9.47274 10.6665 10.6666 9.4726 10.6666 7.99984V3.33317C10.6666 1.86041 9.47274 0.666504 7.99998 0.666504ZM8.49998 12.64C10.8422 12.3905 12.6666 10.4083 12.6666 7.99984C12.6666 7.7237 12.4428 7.49984 12.1666 7.49984C11.8905 7.49984 11.6666 7.7237 11.6666 7.99984C11.6666 10.0249 10.025 11.6665 7.99998 11.6665C5.97494 11.6665 4.33331 10.0249 4.33331 7.99984C4.33331 7.7237 4.10946 7.49984 3.83331 7.49984C3.55717 7.49984 3.33331 7.7237 3.33331 7.99984C3.33331 10.4083 5.15776 12.3905 7.49998 12.64V14.3332H5.99998C5.72384 14.3332 5.49998 14.557 5.49998 14.8332C5.49998 15.1093 5.72384 15.3332 5.99998 15.3332L6.00259 15.3332H7.49998H8.49998H9.99998C10.2761 15.3332 10.5 15.1093 10.5 14.8332C10.5 14.557 10.2761 14.3332 9.99998 14.3332H8.49998V12.64Z",
    fill: "#6E6E76"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioUnmuted);
export default __webpack_public_path__ + "static/media/audio-unmuted.dc04d2d14cfd4c7d10016f36ba4553cd.svg";
export { ForwardRef as ReactComponent };